import { memo, useEffect, useState } from "react"
import { Box } from "@mui/material"

import { OfferDetailsType } from "../../../../../../modules/merchant/admin/products/productsTypes"
import ProductImg from "./ProductImg"
import { OfferTag } from "./OfferTag"
import { FavoriteButton } from "./FavoriteButton"

export const CARD_BORDER_RADIUS = "1rem"

type ProductTopInfoProps = Readonly<{
    productId: number
    imageUrl?: string
    offerDetails?: OfferDetailsType
    isFavoriteProduct: boolean
    handleFavoriteProduct: (id: number, makeFavorite: boolean) => Promise<boolean>
}>

export const ProductTopInfo = memo(
    ({ productId, imageUrl, offerDetails, handleFavoriteProduct, isFavoriteProduct }: ProductTopInfoProps) => {
        const [isFavorite, setIsFavorite] = useState(isFavoriteProduct)

        useEffect(() => {
            setIsFavorite(isFavoriteProduct)
        }, [isFavoriteProduct])

        const handleFavoriteClick = async () => {
            const next = !isFavorite
            const ok = await handleFavoriteProduct(productId, next)
            if (ok) setIsFavorite(next)
        }

        return (
            <Box position="relative">
                <ProductImg imageUrl={imageUrl} />
                {offerDetails && <OfferTag top=".75rem" left=".75rem" offerDetails={offerDetails} size="sm" />}
                <FavoriteButton isFavorite={isFavorite} placement="top-right" onClick={handleFavoriteClick} />
            </Box>
        )
    },
)
